const hotspotBlocks = document.querySelectorAll('.hotspotBlock');
const hotspotMarkers = document.querySelectorAll('.hotspotMarker')

if (hotspotMarkers) {
	hotspotMarkers.forEach(item => {
		item.addEventListener('click', () => {
			// reset hotspot blocks
			hotspotBlocks.forEach( (item) => {
				item.classList.remove('is-active');
				item.setAttribute('aria-hidden', 'true')
			})

			// reset markers
			hotspotMarkers.forEach(item => {
				item.classList.remove('is-active')
				item.setAttribute('aria-expanded', 'false')
			})

			// use hotspot markers data attribute to find id's of targets
			let hotspotData = item.dataset.hotspot;

			// show popup
			let hotspotDataTarget = document.getElementById(hotspotData+'-target')
			hotspotDataTarget.classList.add('is-active')
			hotspotDataTarget.setAttribute('aria-hidden', 'false')
			hotspotDataTarget.setAttribute('tabindex', '-1');
			hotspotDataTarget.focus();

			item.classList.add('is-active')

			item.setAttribute('aria-expanded', 'true');
		})
	})
}
